import React from 'react';
import styled from '@emotion/styled';
import { ChartIcon } from './ChartIcon';
import { DirectoryIcon } from './DirectoryIcon';
import { InsightsIcon } from './InsightsIcon';
import { LiteratureIcon } from './LiteratureIcon';
import { QuestionBankAltIcon } from './QuestionBankAltIcon';
import { QuestionBankIcon } from './QuestionBankIcon';
import { ScheduleIcon } from './ScheduleIcon';

enum LandingCardIcon {
  QuestionBankAltIcon = 'question-bank-alt-icon',
  ScheduleIcon = 'schedule-icon',
  InsightsIcon = 'insights-icon',
  ChartIcon = 'chart-icon',
  DirectoryIcon = 'directory-icon',
  QuestionBankIcon = 'question-bank-icon',
  LiteratureIcon = 'literature-icon',
}

const StyledQuestionBankAltIcon = styled(QuestionBankAltIcon)(({ theme }) => ({
  color: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
  fill: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
}));

const StyledScheduleIcon = styled(ScheduleIcon)(({ theme }) => ({
  color: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
  fill: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
}));

const StyledInsightsIcon = styled(InsightsIcon)(({ theme }) => ({
  color: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
  fill: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
}));

const StyledChartIcon = styled(ChartIcon)(({ theme }) => ({
  color: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
  fill: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
}));

const StyledDirectoryIcon = styled(DirectoryIcon)(({ theme }) => ({
  color: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
  fill: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
}));

const StyledQuestionBankIcon = styled(QuestionBankIcon)(({ theme }) => ({
  color: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
  fill: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
}));

const StyledLiteratureIcon = styled(LiteratureIcon)(({ theme }) => ({
  color: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
  fill: theme.isTrinityThemed ? theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main : theme.palette.primary.main,
}));

type IconRendererProps = {
  icon: string;
  className?: string;
  size?: number;
  width?: number;
  height?: number;
  alt?: string;
};

const iconComponentMap = {
  [LandingCardIcon.QuestionBankAltIcon]: StyledQuestionBankAltIcon,
  [LandingCardIcon.ScheduleIcon]: StyledScheduleIcon,
  [LandingCardIcon.InsightsIcon]: StyledInsightsIcon,
  [LandingCardIcon.ChartIcon]: StyledChartIcon,
  [LandingCardIcon.DirectoryIcon]: StyledDirectoryIcon,
  [LandingCardIcon.QuestionBankIcon]: StyledQuestionBankIcon,
  [LandingCardIcon.LiteratureIcon]: StyledLiteratureIcon,
};

export const LandingCardIconRenderer: React.FC<IconRendererProps> = ({ 
  icon, 
  className, 
  size = 40,
  width,
  height,
  alt = 'Landing card icon',
}) => {
  // Check if icon is a preset enum value
  const IconComponent = iconComponentMap[icon as LandingCardIcon];
  
  if (IconComponent) {
    return (
      <IconComponent 
        className={className} 
        size={size}
      />
    );
  }
  
  // Fallback to image for URL-based icons
  return (
    <img 
      src={icon} 
      alt={alt}
      className={className}
      style={{ width: width || size, height: height || size }}
    />
  );
};
